import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, schema }) => {
  const baseTitle = 'Angel & Devil Network';
  const fullTitle = title ? `${title} – ${baseTitle}` : baseTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Standard Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Angel & Devil Network" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      
      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
      
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <meta name="keywords" content="Webcam Agency, Webcam Karriere, Webcam Studio Deutschland, Erotik Webcam Netzwerk, Professionelles Streaming Equipment, Lovense Starterpaket, Strip-Chat Agentur, myDirtyHobby Unterstützung" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="de" />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default SEO;
